console.log('wesign.js')


// document.addEventListener("DOMContentLoaded", () => {

// });



var menos = document.querySelector('#menos')
const hamburgerContainer = document.querySelector('.menu--hamburger--container');
const menuDiv = document.querySelector('#menos > div');
const menuCollection = menos.querySelector('.header__menu-child');

const linkCollection = menos.querySelector('.container__link-hoverable > a');

if(window.innerWidth < 780){
  const buttonClose = document.createElement('button');
  buttonClose.classList.add('button-close')
  menuDiv.appendChild(buttonClose);


  buttonClose.addEventListener('click', () => {
    menuDiv.classList.remove('open');
    menos.classList.remove('open');
    document.body.classList.remove('overflow-hidden-fixed')
  })
}

// hamburgerContainer.addEventListener('click', () => {
//   menuDiv.classList.toggle('open');
//   menos.classList.toggle('open');
// });



hamburgerContainer.addEventListener('click', () => {
  console.log('hamb click')
  menuDiv.classList.add('open');
  menos.classList.add('open');
  document.body.classList.add('overflow-hidden-fixed')
  
})
// filterClose.onclick = function () {
//   filterModal.classList.remove("open");
//   document.body.style.overflow = '';
// }
window.addEventListener('click', (event) => {
//window.onclick = function (event) {
  console.log('window click')
  if (event.target == menos) {
      menuDiv.classList.remove('open');
      menos.classList.remove('open');
      menuCollection.classList.remove('open')
      document.body.classList.remove('overflow-hidden-fixed')
      
  }
})
if(window.innerWidth < 780){

  linkCollection.addEventListener('click', (e) => {
    console.log('link')
    e.preventDefault();
    e.stopPropagation();
    menuCollection.classList.toggle('open')
  })
}
menuCollection.addEventListener('click', (e) => {
  menuCollection.classList.toggle('open')
})

//hoverable.addEventListener('click', (e) => {console.log('keqsl')
    // e.preventDefault();
    // e.stopPropagation();
    // console.log('kel')
    // //var petitMenu = hoverable.querySelector('.header__menu-child')
    // var petitMenu = hoverable.nextSibling
    // console.log(petitMenu)
    // //hoverable.querySelector('.header__menu-child').classList.toggle('open');
  //});

  /*window.addEventListener('scroll', () => {
   console.log('qcrol')
   menuDiv.classList.remove('open');
  });*/